import { FontConfig } from "../types"

export const HEADING_6_CONFIG: FontConfig = {
  title: "Headings/h6",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 14, tw: "text-[14px]" },
    lineHeight: { px: 21, tw: "leading-[21px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 20, tw: "text-[20px]" },
    lineHeight: { px: 30, tw: "leading-[30px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 26, tw: "text-[26px]" },
    lineHeight: { px: 39, tw: "leading-[39px]" },
  },
}
